import { defineMessages } from 'react-intl';

export const i18n: {
	archived: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	archived: {
		id: 'search-page.filters.names.archived',
		defaultMessage: 'Show archived content',
		description: 'Label for filtering by archived or current content',
	},
});
